module.exports = __webpack_public_path__ + "static/media/followup_date_preview.f0f4381d.jpg";